import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'CUSTOMER_SATISFACTION';

export const {action: dismissNps} = createAction(`${domain}/DISMISS_NPS`, () => ({}));
